import { createSelector } from 'reselect';

import type RootState from 'app-components/utils/redux-store/rootState';

import { TAX_FORMS_REDUCER_KEY, type TaxFormRecord } from './taxFormsTypes';

type State = Pick<RootState, typeof TAX_FORMS_REDUCER_KEY>;

export const getTaxFormsStore = (state: State) => state[TAX_FORMS_REDUCER_KEY];

export const getResourcesById = (state: State) => getTaxFormsStore(state).resourcesById;
export const getLoadPending = (state: State) => getTaxFormsStore(state).loadPending;
export const getIsLoading = (state: State) => getTaxFormsStore(state).isLoading;
export const getError = (state: State) => getTaxFormsStore(state).error;
export const getLastSyncDate = (state: State) => getTaxFormsStore(state).lastSyncDate;

export const getTaxFormForId = (state: State, id: string): TaxFormRecord | undefined => getResourcesById(state).get(id);

export const getTaxForms = createSelector(getResourcesById, (formsById) =>
  formsById.toList().sortBy((form) => form.displayOrder),
);
